// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25155
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 25155
import { eventTrackingUtils } from "@/utils/eventTrack/eventTrackingUtils";
export const PageId = Object.freeze({
  My_Reviews: "My_Reviews",
});

interface IPVTrackParamsRecord {
  /** 我的评价页 */
  My_Reviews: undefined;
}

const sendPv = {
  /** PV-我的评价页 */
  My_Reviews: () => {
    eventTrackingUtils.submitPV({ page_id: PageId.My_Reviews });
  },
};

interface IExpoTrackParamsRecord {
  /** 待评价tab下列表曝光 */
  My_Reviews_WaitingReviews_List: {
    /** 订单id  */
    orderId: string;
    /** 商品id  */
    skuid: string;
  };
  /** 已完成评价tab下评价曝光 */
  My_Reviews_Completed_ReviewsList: {
    /** 订单id  */
    orderId: string;
    /** 评价id  */
    commentId: string;
    /** 商品id  */
    skuid: string;
  };
  /** tab曝光 */
  My_Reviews_Tab_Expo: {
    /** tab名称  */
    tab_name: string;
  };
  /** 已完成评价tab下按钮曝光 */
  My_Reviews_Completed_Btn_Expo: {
    /** 按钮名称  */
    button_name: string;
    /** 评价id  */
    commentId: string;
  };
  /** 更多浮层项曝光 */
  My_Reviews_More_Layer_Expo: {
    /** 按钮名称  */
    button_name: string;
    /** 评价id  */
    commentId: string;
  };
  /** 待评价tab下去评价按钮曝光 */
  My_Reviews_WaitingReviews_List_Review_Expo: {
    /** 订单id  */
    orderId: string;
    /** 商品id  */
    skuid: string;
  };
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord, string>> = Object.freeze({
  /** 待评价tab下列表曝光 */
  My_Reviews_WaitingReviews_List: "My_Reviews_WaitingReviews_List",
  /** 已完成评价tab下评价曝光 */
  My_Reviews_Completed_ReviewsList: "My_Reviews_Completed_ReviewsList",
  /** tab曝光 */
  My_Reviews_Tab_Expo: "My_Reviews_Tab_Expo",
  /** 已完成评价tab下按钮曝光 */
  My_Reviews_Completed_Btn_Expo: "My_Reviews_Completed_Btn_Expo",
  /** 更多浮层项曝光 */
  My_Reviews_More_Layer_Expo: "My_Reviews_More_Layer_Expo",
  /** 待评价tab下去评价按钮曝光 */
  My_Reviews_WaitingReviews_List_Review_Expo: "My_Reviews_WaitingReviews_List_Review_Expo",
});

interface IClickTrackParamsRecord {
  /** tab点击 */
  My_Reviews_Tab: {
    /** tab名称  */
    tab_name: string;
  };
  /** 已完成评价tab下按钮点击 */
  My_Reviews_Completed_Btn: {
    /** 按钮名称  */
    button_name: string;
    /** 评价id  */
    commentId: string;
  };
  /** 更多浮层项点击 */
  My_Reviews_More_Layer: {
    /** 按钮名称  */
    button_name: string;
    /** 评价id  */
    commentId: string;
  };
  /** 待评价tab下列表评分点击 */
  My_Reviews_WaitingReviews_List_Star: {
    /** 订单id  */
    orderId: string;
    /** 商品id  */
    skuid: string;
  };
  /** 待评价tab下去评价按钮点击 */
  My_Reviews_WaitingReviews_List_Review: {
    /** 订单id  */
    orderId: string;
    /** 商品id  */
    skuid: string;
  };
  /** 已完成评价视频图片点击 */
  My_Reviews_Picture: {
    /** 素材类型  */
    material_type: string;
    /** 评价id  */
    commentId: string;
  };
}

const sendClickTrack = {
  /** 点击事件上报-tab点击 */
  My_Reviews_Tab: (json_param: IClickTrackParamsRecord["My_Reviews_Tab"]) => {
    eventTrackingUtils.submitCL({ event_id: "My_Reviews_Tab", json_param });
  },
  /** 点击事件上报-已完成评价tab下按钮点击 */
  My_Reviews_Completed_Btn: (json_param: IClickTrackParamsRecord["My_Reviews_Completed_Btn"]) => {
    eventTrackingUtils.submitCL({ event_id: "My_Reviews_Completed_Btn", json_param });
  },
  /** 点击事件上报-更多浮层项点击 */
  My_Reviews_More_Layer: (json_param: IClickTrackParamsRecord["My_Reviews_More_Layer"]) => {
    eventTrackingUtils.submitCL({ event_id: "My_Reviews_More_Layer", json_param });
  },
  /** 点击事件上报-待评价tab下列表评分点击 */
  My_Reviews_WaitingReviews_List_Star: (json_param: IClickTrackParamsRecord["My_Reviews_WaitingReviews_List_Star"]) => {
    eventTrackingUtils.submitCL({ event_id: "My_Reviews_WaitingReviews_List_Star", json_param });
  },
  /** 点击事件上报-待评价tab下去评价按钮点击 */
  My_Reviews_WaitingReviews_List_Review: (json_param: IClickTrackParamsRecord["My_Reviews_WaitingReviews_List_Review"]) => {
    eventTrackingUtils.submitCL({ event_id: "My_Reviews_WaitingReviews_List_Review", json_param });
  },
  /** 点击事件上报-已完成评价视频图片点击 */
  My_Reviews_Picture: (json_param: IClickTrackParamsRecord["My_Reviews_Picture"]) => {
    eventTrackingUtils.submitCL({ event_id: "My_Reviews_Picture", json_param });
  },
};

export { EXPOSURE_RECORD, sendClickTrack, sendPv };
export type { IExpoTrackParamsRecord };
